module.exports = { src: __webpack_public_path__ + "media/tile-2-image.8df363d5.webp", width: 540, height: 375 };